import { ChangePassword } from '@unistocks/features/settings/change-password';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function TenantChangePasswordScreen() {
  return (
    <>
      <Head>
        <title>{t('AbpAccount::ProfileTab:Password')}</title>
      </Head>
      <ChangePassword />
    </>
  );
}
